import { z } from "zod/mini"

import { EmbedLegacySchema } from "./legacy/embed"

export const EmbedContentType = "EmbedContent" as const

export const EmbedContentSchema = z.extend(EmbedLegacySchema, {
	__TYPE__: z.literal(EmbedContentType),
	all: z.unknown(),
})

export type EmbedContent = z.infer<typeof EmbedContentSchema>
